import { DataGridPremium, GridColDef, GridRenderCellParams, useGridApiRef } from '@mui/x-data-grid-premium';
import { Status, useFetch } from '../../hooks/useFetch';
import {  useMemo, useState } from 'react';
import dayjs from 'dayjs'
import { Message } from '@aviation/cabinapp-message-service-sdk';
import DelayCommDetails from './DelayCommDetails';

export interface IMessageListGridProps {
    dateFrom?: string;
    dateTo?: string;
    addedItem? : Message;
}

function DelayCommListGrid(props : IMessageListGridProps) {
    const apiRef = useGridApiRef();
    const { status, data = [] } = useFetch<Array<Message>>(`/api/message/from/${props.dateFrom}/to/${props.dateTo}`);
    const [ showDetails, setShowDetails ] = useState<boolean>(false);
    const [ currentMessage, setCurrentMessage ] = useState<Message | undefined>(undefined);
    
    const rowId = (row : any) => {
        return row.Id;
    }
    const rows = useMemo(() => {
        var source = (data ?? []);

        if(props.addedItem !== undefined) {        
            source.unshift(props.addedItem!);
        }

        var result = data?.map(o => { return {
            ...o,
            id: rowId(o),
        }}) ?? [];
        
        return result.sort((a,b) => (a.CreatedOn ?? (dayjs().toISOString()) < (b.CreatedOn ?? (dayjs().toISOString())) ? 1 : -1));
    }, [data, props]);

    const columns: GridColDef[] = [
        { field: 'Category', headerName: 'Category', minWidth: 140 },
        { field: 'Title', headerName: 'Title', minWidth: 180 },
        { field: 'Message', headerName: 'Message', minWidth: 400 },
        { field: 'Reason', headerName: 'Reason', minWidth: 400 },
        { field: 'CreatedOn', headerName: 'Created on', minWidth: 120, renderCell: (params: GridRenderCellParams<Date>) => dayjs(params.value).format('DD.MM.YYYY HH:mm')  },
    ];

    return (
    <>
        <DataGridPremium
            apiRef={apiRef}
            autoHeight
            rows={rows}
            columns={columns}
            editMode='row'
            isCellEditable={(o) => false}
            rowSelection={true}
            
            // pageSize={10}
            // rowsPerPageOptions={[10]}
            getRowClassName={(params) => { return params.indexRelativeToCurrentPage % 2 === 1 ? `tui-grid-alternate-row` : ''}}
            pagination
            loading={status === Status.Fetching || status === Status.Idle}
            onRowClick={(params) => {setCurrentMessage(params.row); setShowDetails(true)}}
        />
        { currentMessage && <DelayCommDetails open={showDetails} item={currentMessage} cancelAction={() => {setShowDetails(false);}} />}
    </>
        
    );
}

export default DelayCommListGrid;